
import { Component, Prop, Vue } from "vue-property-decorator";
import { GlobalColorGroup } from "@/types/colors";
import {
  toggleSectionColors,
  isSectionUsingDarkBackgroundColor
} from "@/subapps/onboarding/lib/color";
import iframeManager from "@/subapps/onboarding/lib/iframeManager";
import { logEvent } from "@/util/tracking";
@Component({})
export default class NodeOnboardingPaletteButton extends Vue {
  @Prop({ required: true }) colorGroup!: GlobalColorGroup;
  @Prop({ required: true }) elementId!: number;
  @Prop({ default: false }) sendRequest!: boolean;

  async applyColor() {
    logEvent("Onboarding", {
      action: "onboarding_app_ui_interaction",
      type: this.sendRequest
        ? "sidebar_toggle_section_colors_button"
        : "node_toggle_section_color_button"
    });

    if (this.sendRequest) {
      await iframeManager.sendRequest({
        payload: {
          action: "toggleSectionColors",
          data: {
            elementId: this.elementId,
            colorGroup: this.colorGroup
          }
        }
      });
    } else {
      await toggleSectionColors(this.elementId, this.colorGroup);
    }
  }

  get isUsingDark() {
    return isSectionUsingDarkBackgroundColor(this.elementId, this.colorGroup);
  }
}
